module.exports = __webpack_public_path__ + "media/images/area/feature/kanto/05-94ec830ce09aad747a1b8276ef25bdf5.jpg";